import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-po-report',
  templateUrl: './po-report.component.html',
  styleUrls: ['./po-report.component.css']
})
export class PoReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
